import { useQuery } from '@tanstack/react-query';

import type { TermsAndConditionsBrand } from '~/consts/termsAndConditions';

import { getTermsAndConditions } from '~/services/ContentService';

import { termsAndConditionsQueryKeys } from './termsAndConditionsQueryKeys';

interface UseGetTermsAndConditionsOptions {
  enabled?: boolean;
}

export function useGetTermsAndConditions(
  brand: TermsAndConditionsBrand,
  slug: string,
  locale: string,
  options: UseGetTermsAndConditionsOptions = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: termsAndConditionsQueryKeys.detail(brand, slug, locale),
    queryFn: async ({ signal }) => {
      return await getTermsAndConditions(brand, slug, locale, { signal });
    },
    enabled: enabled && !!slug && !!locale,
  });
}
